import { createFileRoute, useNavigate } from '@tanstack/react-router'
import { toast } from 'sonner'
import { useObservable } from '@legendapp/state/react'
import { useEffect } from 'react'
import { useManager, useStatus } from 'tinytick/ui-react'

export const Route = createFileRoute('/auth/callback')({
  component: OAuthCallbackComponent,
})

function OAuthCallbackComponent() {
  const manager = useManager();
  const navigate = useNavigate();

  const state$ = useObservable({
    error: null as string | null,
  });

  useEffect(() => {
    const processCallback = async () => {
      const params = new URLSearchParams(window.location.search);
      const code = params.get('code');
      const state = params.get('state');
      const error = params.get('error');

      if (error) {
        toast.error(`Authentication Failed: ${error}`);
        return;
      }

      if (!code) {
        toast.error('Invalid or Missing Authorization Code');
        return;
      }

      // Validate State Parameter
      const storedState = sessionStorage.getItem('oauthState');
      if (!state || state !== storedState) {
        toast.error('Invalid or Missing State Parameter');
        sessionStorage.removeItem('oauthState');
        return;
      }

      try {
        manager?.scheduleTaskRun('handleOAuthCallback', code);

        navigate({ to: '/' });
      } catch (error) {
        state$.error.set(error as string);
        return;
      }
    }


    processCallback();
  }, [navigate, useStatus()]);

  if (state$.error.get()) {
    return (
      <div className="flex flex-col items-center justify-center h-full">
        <h1 className="text-2xl font-bold text-red-500 mb-4">Authentication Error</h1>
        <p>{JSON.stringify(state$.error.get())}</p>
        <button
          className="mt-4 px-4 py-2 bg-primary text-white rounded-md"
          onClick={() => navigate({ to: "/login" })}
        >
          Return to Login
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-full">
      <div className="text-center">
        <h1 className="text-2xl font-bold mb-4">Authenticating</h1>
        <p className="text-gray-600">Please wait while we authenticate you...</p>
      </div>
    </div>
  );
}
